const formOptions = {
  eventFormats: [
    {
      label: "Virtual",
      value: "Virtual",
    },
    {
      label: "In Person",
      value: "In Person",
    },
    {
      label: "Hybrid",
      value: "Hybrid",
    },
  ],
  eventTypes: [
    {
      label: "Off-site",
      value: "Off-site",
    },
    {
      label: "On-site",
      value: "On-site",
    },
  ],
  offices: [
    {
      label: "Boston",
      value: "Boston",
    },
    {
      label: "Hartford",
      value: "Hartford",
    },
    {
      label: "Boston & Hartford (New England)",
      value: "Boston & Hartford (New England)",
    },
  ],
  dressCode: [
    {
      label: "Business",
      value: "Business",
    },
    {
      label: "Business Casual",
      value: "Business Casual",
    },
    {
      label: "Casual",
      value: "Casual",
    },
  ],
  eventTags: [
    { label: "Aspire", value: "Aspire" },
    { label: "Corporate Citizenship", value: "Corporate Citizenship" },
    { label: "Community of Practice (CoP)", value: "Community of Practice (CoP)" },
    { label: "Learning", value: "Learning" },
    { label: "Market-Wide", value: "Market-Wide" },
    { label: "Military", value: "Military" },
    { label: "Partners for Good", value: "Partners for Good" },
    { label: "Prism", value: "Prism" },
    { label: "REACH", value: "REACH" },
    { label: "Slalom Women", value: "Slalom Women" },
    { label: "Social", value: "Social" },
    { label: "Unidos", value: "Unidos" },
    { label: "Wellness", value: "Wellness" },
    { label: "Other", value: "Other" },
  ],
  distributionList: [
    {
      label: "New England - All (newenglandall@slalom.com)",
      value: "newenglandall@slalom.com",
      prod: true,
    },
    {
      label: "New England Events (newenglandevents@slalom.com) (Selecting this option will create your event without notifying the market)",
      value: "newenglandevents@slalom.com",
      prod: true,
    },
    {
      label: "Boston All (boston-all@slalom.com)",
      value: "boston-all@slalom.com",
      prod: true,
    },
        {
      label: "Hartford All (hartford-all@slalom.com) ",
      value: "hartford-all@slalom.com",
      prod: true,
    },
    {
      label: "Test Distribution List 1 (GatherTestingDL@slalom.com)",
      value: "GatherTestingDL@slalom.com",
      prod: false,
    },
    {
      label: "Test Distribution List 2 (GatherTestTwo@slalom.com)",
      value: "GatherTestTwo@slalom.com",
      prod: false,
    },
    {
      label: "New England Community – Aspire (NewEnglandCommunity-Aspire@slalom.com)",
      value: "NewEnglandCommunity-Aspire@slalom.com"
    },
    {
      label: "New England Community – Military (NewEnglandCommunity-Military@slalom.com)",
      value: "NewEnglandCommunity-Military@slalom.com"
    },
    {
      label: "New England Community - PFG (NewEnglandCommunity-PFG@slalom.com)",
      value: "NewEnglandCommunity-PFG@slalom.com"
    },
    {
      label: "New England Community – Prism (NewEnglandCommunity-Prism@slalom.com)",
      value: "NewEnglandCommunity-Prism@slalom.com"
    },
    {
      label: "New England Community – REACH (NewEnglandCommunity-REACH@slalom.com)",
      value: "NewEnglandCommunity-REACH@slalom.com"
    },
    {
      label: "New England Community – Unidos NewEnglandCommunity-Unidos@slalom.com",
      value: "NewEnglandCommunity-Unidos@slalom.com"
    },
    {
      label: "New England Community – Wellness NewEnglandCommunity-Wellness@slalom.com",
      value: "NewEnglandCommunity-Wellness@slalom.com"
    },
    {
      label: "New England Community – Women (NewEnglandCommunity-Women@slalom.com)",
      value: "NewEnglandCommunity-Women@slalom.com"
    }
  ],
};

export default formOptions;
